import { Badge } from '@/components/ui/badge';

const STATUS_BADGE_CLASSES = {
  completed: 'bg-green-100 text-green-800',
  pending: 'bg-yellow-100 text-yellow-800',
  processing: 'bg-blue-100 text-blue-800',
  failed: 'bg-red-100 text-red-800',
} as const;

export function documentStatusBadgeClass(status: string) {
  return STATUS_BADGE_CLASSES[status as keyof typeof STATUS_BADGE_CLASSES] || 'bg-gray-100 text-gray-800';
}

export function DocumentStatusBadge({ status }: { status: string }) {
  return <Badge className={documentStatusBadgeClass(status)}>{status}</Badge>;
}
